import { render, staticRenderFns } from "./RecordDownloadStatus.vue?vue&type=template&id=fc03bdc8"
import script from "./RecordDownloadStatus.vue?vue&type=script&lang=js"
export * from "./RecordDownloadStatus.vue?vue&type=script&lang=js"
import style0 from "./RecordDownloadStatus.vue?vue&type=style&index=0&id=fc03bdc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VProgressLinear})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
